import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CountWithStatus } from '@/components/modules/Typography/TagText/CountWithStatus';
import { clientRfpOneInterviewPath } from '@/utils/router/links';
export const RfpClientCountInterview = (props) => {
    const { className = '', id, isEnd, selectableOfferCount } = props;
    // ステータス
    const statusConfig = {
        color: 'orange',
        text: '未登録',
    };
    // 面談可能な提案件数
    const countConfig = {
        inactive: false,
        link: clientRfpOneInterviewPath(id),
        number: selectableOfferCount,
    };
    return (_jsx(CountWithStatus, { className: className, countConfig: countConfig, inactiveAll: selectableOfferCount === 0 || isEnd, statusConfig: statusConfig }));
};
